// Error de lectura (rediseño, docs/PLAN-REDISENO-PORTAL.md §6.9): titulo,
// por que y "Reintentar". El portal reintenta solo igual; el boton es para
// quien no quiere esperar. Se anuncia como alerta: es lo que pasa ahora.
import { Button } from "./button.js";
import { cn } from "./cn.js";
import { Icon } from "./icon.js";

interface Props {
  title: string;
  children?: React.ReactNode;
  /** Sin `onRetry` no hay boton: la lectura no se puede repetir desde aca. */
  onRetry?: () => void;
  retryLabel?: string;
  className?: string;
}

export function Failure({ title, children, onRetry, retryLabel = "Reintentar", className }: Props): React.JSX.Element {
  return (
    <div role="alert" className={cn("flex flex-wrap items-center gap-x-3.5 gap-y-2.5 rounded-md border border-critico/35 bg-critico/8 px-3.5 py-3", className)}>
      {/* Icono, no texto: el textContent del aviso es solo el mensaje. */}
      <span aria-hidden="true" className="grid size-[22px] shrink-0 place-items-center rounded-sm bg-critico/20 text-critico-texto">
        <Icon name="alerta" className="size-3.5" />
      </span>
      <div className="min-w-0 flex-[1_1_260px]">
        <p className="m-0 text-sm font-semibold text-critico-texto">{title}</p>
        {children !== undefined && <p className="m-0 text-xs leading-normal text-texto-2">{children}</p>}
      </div>
      {onRetry !== undefined && (
        <Button variant="secundario" size="sm" onClick={onRetry}>
          <Icon name="actualizar" />
          {retryLabel}
        </Button>
      )}
    </div>
  );
}
